<template>
  <v-app>
    <v-main>
      <v-container>
        <v-dialog
            :value="alertnuevo"
            persistent
            max-width="380"
        >
          <v-card>
            <v-card-title class="text-h5">
              {{ $t('alertas.titulodatos') }}
            </v-card-title>
            <v-card-text>
             YA  ESTAS PARTICIPANDO!
            </v-card-text>
            <v-card-actions>
              <v-btn
                  color="green darken-1"
                  text
                  @click="alertnuevo = false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>

        </v-dialog>

        <v-row  justify="center">
          <v-col  cols="12" sm="12" lg="9" md="9">

            <v-alert
                :value="alertnoacepto"
                color="red"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
             Tienes que Aceptar las Condiciones
            </v-alert>
            <v-alert
                :value="alertnuevo"
                color="primary"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Estás Participando Mucha Suerte!!m
            </v-alert>
            <v-card>
              <v-card-title>
              Participa al Sorteo con {{negocio.negocio}}
              </v-card-title>
              <v-card-text>
            <section id="main-cabecera" class="mb-4">
              <v-row align="center" class="text-center">
                <v-col cols="12" sm="12" md="12" lg="12">
                  <h1 v-if="logoexist" class="display-1 font-weight-bold">
                    <v-img width="150" :src="logoimg" />
                  </h1>
                </v-col>
              </v-row>
              <v-row  justify="space-between">
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-form ref="form">
                    <v-row>
                      <v-col  cols="6" sm="6" md="4">
                        <v-autocomplete
                            v-model="editedItem.socioPrincipal.tipoDocumento"
                                         :items="tiposdoc"
                                         item-text="tipoDocumento"
                                         return-object
                                         label="Tipo de Documento">

                        </v-autocomplete>
                      </v-col>
                      <v-col cols="6" sm="6" md="4">
                        <v-text-field v-model="editedItem.socioPrincipal.dni" label="Numero de Documento" required></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="4">
                        <v-text-field v-model="editedItem.socioPrincipal.email" :label="$t('formularios.Email')" required></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="4">
                        <v-text-field v-model="editedItem.socioPrincipal.nombre" :label="$t('formularios.nombres')"></v-text-field>
                      </v-col>
                      <v-col cols="6" sm="6" md="4">
                        <v-text-field v-model="editedItem.socioPrincipal.apellidoPaterno" :label="$t('formularios.ApPaterno')"></v-text-field>
                      </v-col>
                      <v-col v-if="negociodisenio.campoapmaterno" cols="6" sm="6" md="4">
                        <v-text-field v-model="editedItem.socioPrincipal.apellidoMaterno" :label="$t('formularios.ApMaterno')"></v-text-field>
                      </v-col>
                      <v-col v-if="negociodisenio.campotelefono" cols="6" sm="6" md="4">
                        <v-text-field type="number" v-model="editedItem.socioPrincipal.telefono" :label="$t('formularios.Telefono')"></v-text-field>
                      </v-col>
                      <v-col v-if="negociodisenio.campodireccion" cols="6" sm="6" md="4">
                        <v-text-field  v-model="editedItem.socioPrincipal.direccion" :label="$t('formularios.Direccion')"></v-text-field>
                      </v-col>
                      <v-col v-if="negociodisenio.campodistrito" cols="6" sm="6" md="4">
                        <v-autocomplete  v-model="editedItem.socioPrincipal.distrito" :items="distritos"  item-text="distrito" persistent-hint
                                         return-object
                                          :label="$t('formularios.EscogerDistrito')"></v-autocomplete>
                      </v-col>
                      <v-col v-if="negociodisenio.camposexo" cols="6" sm="6" md="4">
                        <v-autocomplete  v-model="editedItem.socioPrincipal.sexo" :items="sexos"  item-text="sexo"  persistent-hint
                                         return-object
                                          label="Escoger Sexo"></v-autocomplete>
                      </v-col>
                      <v-col v-if="negociodisenio.campofecnac" cols="6" sm="6" md="4">
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="editedItem.socioPrincipal.fechaNacimiento"
                                :label="$t('formularios.FechaNacimiento')"
                                readonly
                                @blur="date = editedItem.socioPrincipal.fechaNacimiento"
                                v-on="on"
                                v-bind="attrs"
                                prepend-icon="fas fa-calendar"
                            ></v-text-field></template>
                          <v-date-picker
                              v-model="date"
                              :active-picker.sync="activePicker"
                              min="1950-01-01"
                              locale="es-es"
                              :max="fechamax"
                              @change="editedItem.socioPrincipal.fechaNacimiento = date"
                              @input="menu1 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">

                        <v-checkbox
                            v-model="editedItem.aceptoCondicion"
                            :rules="[v => !!v || 'Debes aceptar para continuar']"
                            :label="negociodisenio.condiciones"
                            required
                        ></v-checkbox>  </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-btn v-bind:style="btnPag" v-model="boton"  @click="save">Grabar</v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </section>
              </v-card-text> </v-card>
          </v-col>
        </v-row>


      </v-container>
    </v-main>
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-app>
</template>

<script>
import axios from 'axios';
import moment from "moment-timezone";
import store from "@/store";
import sexosjson from "@/assets/json/sexos.json";
import diasjson from "@/assets/json/dias.json";

export default {
  name: "participa",
  components: {
  },
  metaInfo() {
    return {
      title: this.titulonegocio,
        meta: [
      {property: "og:image", content: this.logoimg},
      {property: "og:image:width", content: "699"},
      {property: "og:image:height", content: "366"},
      {
        property: "og:description",
        content: "Participa en "+this.titulonegocio
      }
    ]
    }
  },
  data () {
    return{
      idnegocio: 0,
      overlay:false,
      alertnuevo:false,
      alertnoacepto:false,
      alerterror:false,
      activePicker:null,
      logoexist: false,
      logoimg: null,
      rese:'',
      browser:false,
      normal:true,
      login:false,
      registro:false,
      boton:false,
      menu: false,
      fechamax:null,
      form: {
        nombre: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        dni : "",
        foto: "",
        email: "",
        paisNac:{},
        tipoDocumento: {},
        telefono:"",
        direccion:"",
        fechaNacimiento:new Date().toISOString().substr(0, 10),
        sexo:{},
        fotoDni:"",
        postalCode:"",
        distrito:{},
        createdAt:"",
        uidFirebase: "",
        grupoUsuario:{},
        isprofile: true,
        isfoto : false,
        isverified: false
      },
      email: '',
      password:'',
      error:'',
      password2:'',
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      titulonegocio:'',
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
     hayimagen: false,
      imagen:'',
      token:'',
      imagen2:'',
      paises:[],
      provincias:[],
      ciudades:[],
      distritos: [],
      sexos: [{id:0,sexo:"Escoger Sexo"}, {id:1, sexo:"Masculino"}, {id:2, sexo:"Femenino"}],
      tiposdoc: [],
      negocio:[],
      tiposcarnets:[],
      Contactos:[],
      negociodisenio: {
        campoapmaterno: false,
        campodireccion: false,
        campodistrito: false,
        campofecnac: false,
        campofoto: false,
        campoinvitado: false,
        campoizqder: false,
        camporeferido: false,
        camposexo: false,
        campotelefono: false,
        campofumador: false,
        campotipocarnet: false,

        campocontacto: false,
        campocondiciones:false,
        condiciones: '',
      },
      editedItem: {
        id:0,
        fecha: new Date(),
        estadoCarnet: {
          id:0,
          estadoCarnet:'',
          color: ''
        },
        formaEnvio: {
          id:0,
          formaEnvio:''
        },
        tipoPago : {
          id:0,
          tipoPago:'',
          visiblePagina:true
        },
        tipoMembresia: {
          id:0,
          tipoMembresia:''
        },
        tipoCarnetSocio:{
          id:0,
          tipoCarnet:'',
          frontal:0,
          temporada:{
            id:0,
            negocio:{
              id:0,
              negocio:'',
              cliente:{
              },
              activo:true,
              icono:'',
              logo:'',
              impuesto:'',
              moneda:{
              },
              tag:'',
              latitud:0,
              longitud:0,
              horaApertura: null,
              horaCierre: null,
              tipoNegocio:{},
              direccion:''
            },
            temporada:'',
            activa:true,
            listas:true,
            inscripcion:true,
            createdAt:null
          },
          activo: true,
          backFront:'',
          backBack:'',
          textColor:'',
          descripcion:'',
          basico:true,
          createdAt:null
        },
        temporada:{},
        contacto:{
          id:0,
          contacto:''
        },
        referido:'',
        nroboleta: '',
        valorpago:0,
        aceptoCondicion:false,
        condicionAceptada:'',
        socioPrincipal: {
          id:0,
          nombre:'',
          apellidoMaterno:'',
          apellidoPaterno:'',
          dni:'',
          foto:'',
          email:'',
          fechaNacimiento: null,
          telefono:'',
          direccion:'',
          sexo:{
            id:0,
            sexo:''
          },
          tipoDocumento:{
            id:0,
            tipoDocumento:''
          },
          paisNac:{
            id:0,
          },
          fotoDni:'',
          postalCode:'',
          distrito:{id:0,
          distrito:'',
          ciudad:{
           id:0,
           ciudad:'',
            provincia:{id:0,
            provincia:'',
            pais:{
              id:0,
              pais:''
            }}
          }},
          createdAt:null,
          uidFirebase:'',
          isprofile:false,
          isfoto: false,
          isverified: false,
          socio:false,
        },
        fechaInicio: null,
        fechaFin: null,
      },
      stylePagina: {
        backgroundColor: 'white',
        color:'white'
      },
      btnPag: {
        backgroundColor: 'blue',
        color:'white'
      }

    }
  },

  mounted (){
    this.idnegocio =  this.$route.params.idnegocio;
    this.damedisenio();
    this.fnBrowserDetect();
    this.fechamax =this.formatDatee(new Date(new Date().setFullYear(new Date().getFullYear() - 18)))
    this.date = this.fechamax
    this.editedItem.socioPrincipal.fechaNacimiento = this.formatDatee(this.date);

  }
,
watch: {
  date () {
    this.editedItem.socioPrincipal.fechaNacimiento = this.formatDatee(this.date)
  },
},

  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },


    fnBrowserDetect(){

      let userAgent = navigator.userAgent;

      if(userAgent.match(/chrome|chromium|crios/i)){
        this.rese = "chrome";
        this.browser = true;
      }else if(userAgent.match(/firefox|fxios/i)){
        this.rese = "firefox";
        this.browser = true;
      }  else if(userAgent.match(/safari/i)){
        this.rese = "safari";
        this.browser = true;
      }else if(userAgent.match(/opr\//i)){
        this.rese = "opera";
        this.browser = true;
      } else if(userAgent.match(/edg/i)){
        this.rese = "edge";
        this.browser = true;
      }else{
        this.rese="No browser detection";
        this.browser = false;
      }

    },
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    formatFecha(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    },
    parseDate (date) {
      if (!date) return null

      const [day,month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    dametipodocumentos(){
      this.progr = true;
      axios
          .get('tiposdocumento/pais/'+this.negocio.ciudad.provincia.pais.id,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.tiposdoc = response.data;
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    damedistritos(){
      this.progr = true;
      axios
          .get('distritos/ciudad/'+this.negocio.ciudad.id,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.distritos = response.data;
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    save () {
      if(this.editedItem.aceptoCondicion){
      this.overlay = true;

      var bodyFormData2 = new FormData();

      if (this.editedItem.socioPrincipal.fechaNacimiento === "Fecha inválida"){
        this.editedItem.socioPrincipal.fechaNacimiento = null;
      }else{
        this.editedItem.socioPrincipal.fechaNacimiento = this.formatfechanac(this.editedItem.socioPrincipal.fechaNacimiento)
      }

      bodyFormData2.append("persona",JSON.stringify(this.editedItem.socioPrincipal));
      bodyFormData2.append("negocioId",this.negocio.id);
      bodyFormData2.append("condicion",this.negociodisenio.condiciones);


      axios
          .post('membresia/crear/sorteo',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          }).then(response => {
        let usuariodto = response.data
        console.log(usuariodto);
        this.alertnuevo = true;
        this.overlay = false;
      })
          .catch(error => {
            this.error = "Hubo un error";
            this.alerterror = true
            console.log(error);
            this.overlay = false;
          });

      }else{
        this.alertnoacepto =true
      }
    },


    estaConectado(){
      this.damepaises();

    },
    formatDateee(value) {
      var fec = moment(value).locale('es-pe');

      return fec.tz(this.negocio.cliente.timeZone.timeZone).format("YYYY-MM-DD hh:mm:ss")
    },

    formatfechanac(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },
    registrar(user){
      this.form.uidFirebase = user.uid
      var bodyFormData = new FormData();
      this.form.createdAt = this.formatDateee(new Date())
      this.form.fechaNacimiento = null
      bodyFormData.append('data',JSON.stringify(this.form));
      axios.post("personas/registrar",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            store.dispatch("fetchUsuario", response.data.persona);
            store.dispatch("fetchSexos", sexosjson);
            store.dispatch("fetchDias", diasjson);
            this.editedItem.socioPrincipal = response.data.persona
            store.dispatch("conectarse")
            this.estaConectado();
            this.overlay = false;
          })
          .catch(error => {
            console.log(error)
            this.overlay = false
          });
    },
    cambiaCheck(){
      if(this.editedItem.aceptoCondicion){
       this.boton = true
      }else{
        this.boton = false
      }
    },
    damedisenio(){
      this.progr = true;
      axios
          .get('negociodisenio/sorteos/'+this.idnegocio,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.negociodisenio = response.data;
            this.negocio = response.data.negocio;

            if (this.negocio.logo270 === null){
                this.logoexist = false;
            }else{
              this.logoexist  = true;
              this.logoimg = this.negocio.logo270;
            }
            if (this.negociodisenio.condiciones !== '' && this.negociodisenio.condiciones !== null){
              this.campocondiciones = true
              this.condiciones = this.negociodisenio.condiciones
              this.editedItem.condicionAceptada = this.condiciones
            }
            this.damedistritos()
            this.dametipodocumentos()
            this.titulonegocio = this.negociodisenio.negocio.negocio;
            let objPag= {
              backgroundColor: this.negociodisenio.backgroundColor,
              color:this.negociodisenio.colorText
            }
            let btnPag= {
              backgroundColor: this.negociodisenio.colorBgBoton,
              color:this.negociodisenio.colorTxtBoton
            }
            this.btnPag = btnPag
            this.stylePagina = objPag
          })
          .catch((error)  => {
            console.log(error);
          });
    }
  }
}
</script>
